import { identity } from "@/libs/lodash"

export const createAggregatedProgress = <T = number>({
  coeffs,
  onProgress,
  transform,
}: {
  coeffs: number[]
  onProgress: (progress: number) => void
  transform?: (data: T) => number
}) => {
  const progresses = new Array(coeffs.length).fill(0)
  const t = transform ?? identity

  return (index: number, progress: T) => {
    if (index < 0 || index >= progresses.length) return

    progresses[index] = t(progress)

    onProgress(progresses.reduce((acc, c, idx) => acc + c * coeffs[idx], 0))
  }
}
